"use client";

import Link from "next/link";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { ChevronLeft } from "lucide-react";

function BackLinkInner() {
  const searchParams = useSearchParams();
  const fromWriters = searchParams?.get("from") === "writers";
  const href = fromWriters ? "/writers" : "/";
  const label = fromWriters ? "Back to Writers" : "Back to Home";

  return (
    <Link
      href={href}
      className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground transition-colors mb-10"
    >
      <ChevronLeft className="size-4 mr-1" />
      {label}
    </Link>
  );
}

export function BackLink() {
  return (
    <Suspense
      fallback={
        <Link
          href="/"
          className="inline-flex items-center text-sm font-medium text-muted-foreground hover:text-foreground transition-colors mb-10"
        >
          <ChevronLeft className="size-4 mr-1" />
          Back to Home
        </Link>
      }
    >
      <BackLinkInner />
    </Suspense>
  );
}
